import { Container, Typography } from "@mui/material";
import { TitleWithBody } from "../types/utils";
import CollapsibleText from "./Common/CollapsibleText";

const Faq = () => {
  return (
    <Container disableGutters sx={styles.FaqContainer}>
      <Container disableGutters sx={styles.titleContainer}>
        <Typography variant="h5" align="center" sx={styles.titleText}>
          Korduma Kippuvad Küsimused
        </Typography>
      </Container>
      {FAQs.map((data, index) => {
        return <CollapsibleText key={index} title={data.title} body={data.body} references={data.references} />;
      })}
    </Container>
  );
};

export default Faq;

const styles = {
  FaqContainer: {
    backgroundColor: "white",
    borderRadius: "20px",
    px: "5%",
    pb: "2%",
  },
  titleContainer: {
    display: "flex",
    justifyContent: "center",
    pt: "4%",
    pb: "1%",
  },
  titleText: {
    fontWeight: 550,
  },
};

const FAQs: TitleWithBody[] = [
  {
    title: "Mida mulle ütleb DÜKA alusel saadud skoor?",
    body:
      "DÜKA testi alusel saadud skoor näitab, kuivõrd arusaadav on teie kõne kuulajale. " +
      "Nt tavaline kõneleja, kellel ei ole kõnehäiret, saab skooriks 49-50 punkti 50-st (98-100%). " +
      "Düsartriaga inimese skoor on kõnehäire tekkimisel tavaliselt madalam, kuid kõneteraapia" +
      " käigus peaks see paremaks muutuma. DÜKA abil saate jälgida kõneteraapia edukust. Samas " +
      "peab meeles pidama, et kergema düsartria puhul DÜKA skoor võib osutuda ka algetapil" +
      " maksimaalseks. Sel juhul kõnehäire avaldub mitte üksiksõnade, vaid pikemate ütluste tasandil.",
    references: {},
  },
  {
    title: "Miks DÜKA test on digitaliseeritud? Kas seda saab sooritada „paberi peal“?",
    body:
      "DÜKA test on digitaliseeritud selle jaoks, et testitav sõnaloend oleks iga" +
      " kord unikaalne ning kuulaja ei harjuks sellega ära. „Paberi peal“ testi" +
      " sooritada ei ole produktiivne, sest siis tuleks iga kord välja printida 50" +
      " lehekülge ning seejuures tagada, et testi läbiviimisel osaleks kaks testijat" +
      " (üks näitab sõnu patsiendile, teine hindab kõne arusaadavust).",
    references: {},
  },
  {
    title: "Kas DÜKA testi sooritamiseks peab kuskile panema oma või patsiendi nime? ",
    body: "Ei, isikuandmed las jäägu teadaolevateks ainult testi läbiviijatele ja sooritajale.",
    references: {},
  },
  {
    title: "Kas DÜKA testi sooritamiseks on vaja registreeruda? ",
    body: "Ei, DÜKA veebirakendus on avatud kasutamiseks ilma registreerimata.",
    references: {},
  },
  {
    title: "Milleks on vaja DÜKA proovitesti? ",
    body:
      "Selleks, et katsetada testi läbiviimise protseduuri - nii on teil lihtsam" +
      " päris testi läbi viia. Seejuures patsient proovitesti läbima ei pea.",
    references: {},
  },
  {
    title: "Mitu inimest on vaja, et DÜKA testi läbi viia või läbida? ",
    body:
      "DÜKA testi läbiviimiseks on vaja 2 inimest: isik, kelle kõne " +
      "arusaadavust hinnatakse, ning isik, kes kõne arusaadavust hindab " +
      "(logopeed või lihtsalt hea sõber).",
    references: {},
  },
  {
    title: "Mida mul läheb vaja DÜKA testi läbiviimiseks? ",
    body:
      "DÜKA läbiviimiseks peab teil olema arvuti, tahvelarvuti või nutitelefon, " +
      "välja printimise võimalus (enne testi tuleb välja printida hindamisleht " +
      "ning testi lõpetamisel õigete vastustega leht), " +
      "pastakas, soovi korral klaas vett (et testi sooritaja saaks pausi ajal juua) ja " +
      "vajadusel diktofon (helisalvestust saab hiljem vigade analüüsimiseks kasutada).",
    references: {},
  },
  {
    title: "Kui pikk on DÜKA testi sooritamise protsess? ",
    body:
      "Koos ettevalmistuse ja hindamisega võtab DÜKA testi läbiviimine" +
      " maksimaalselt 30 min, s.h testimine iseenesest - 7-10 min.",
    references: {},
  },
  {
    title: "Kas DÜKA testi sisu on alati üks ja sama? ",
    body:
      "Ei, arvutiprogramm koostab iga kord uue unikaalse sõnaloendi. " +
      "Unikaalne sõnaloend toetub omakorda 600-sõnalisele sõnakogumile, " +
      "mis sisaldab 50 allkogumit ning iga allkogum koosneb 12 sarnase kõlapildiga sõnast. ",
    references: {},
  },
  {
    title: "Kuidas saan teada minu või minu patsiendi sooritatud DÜKA testi tulemust? ",
    body:
      "DÜKA testi tulemust saate arvutada ise, võrreldes hindamislehel märgitud" +
      " sõnu õigete sõnade loendiga. Õigete sõnade loend ilmub „Vastuste lehena“ " +
      "peale testi sooritamist (seda saab enda arvutisse või nutitelefoni alla laadida). " +
      "Vastuste lehel on toodud sooritaja tinglik nimi, kuupäev ning testis esitatud " +
      "unikaalne sõnaloend. Iga õigesti tuvastatud sõna annab 1 punkt." +
      " Testi sooritus tervikuna annab maksimaalselt 50 punkti, mis võrdub 100%-le." +
      " Kui saadud skoor on väiksem, nt 37 punkti, siis tuleb teil arvutada, " +
      "mitu protsendi annab see 50 punktist. Nõuanne: lihtsam viis protsente " +
      "arvutada on 37 : 50 = 0,74 ehk testi skoor on 74%.",
    references: {},
  },
  {
    title: "Kas ja kui kaua säilib DÜKA testi konkreetse soorituse unikaalne sõnade kogum? ",
    body:
      "DÜKA testi konkreetse soorituse unikaalne sõnade kogum " +
      "on saadaval kohe peale testi läbimist („Vastuste leht“). Seda saab arvutisse " +
      "alla laadida ning soovi korral välja printida. ",
    references: {},
  },
  {
    title: "Mitu korda saab DÜKA testi sooritada? ",
    body: "DÜKA testi saab sooritada piiramatult.",
    references: {},
  },
  {
    title: "Kas on oodata DÜKA testi edasiarendust? ",
    body:
      "Paari lähema aasta jooksul loodame luua DÜKA testi lauselise osa," +
      " mis võimaldaks hinnata kõne arusaadavust lausungi tasemel. " +
      "Plaanis on luua ka DÜKA testi venekeelne versioon.",
    references: {},
  },
  {
    title: "Kas sa ei leidnud vastust oma küsimusele?",
    body: "[Võta meiega ühendust!][1]",
    references: {
      "1": "/kontakt",
    },
  },
];
